export default __webpack_public_path__ + "static/media/audio3_face.019d1764.m4a";